export const TITLE_CHARACTER_LIMIT = 128;
export const SKILLS_MAX_LIMIT = 15;
